/**
 * 악덕알리미 로그인.
 *  "장비불러 계정으로 빠른 시작" → 악덕 네이티브 앱이 장비불러앱을 통해 onetime 토큰을 발급받고
 *  badcall://login?token= 딥링크로 회신 → WebView 가 /b/login/onetime?token= 으로 진입(세션 로그인).
 *  (토큰 소비: OneTimeLoginController@consume)
 */
import Util from '../../Common/Util';

// 장비불러 앱이 없을 때 빠른 시작 대신 띄우는 안내 — 설치를 권하거나 마켓으로 보내지 않는다(원스토어 심사).
//   앱(dv MainActivity.JB_MISSING_MSG)의 예비 안내와 같은 문장.
const JB_MISSING_MSG = '장비불러 앱이 설치되지 않아 아이디·비밀번호로 로그인해 주세요.';

export default class Login {
    initialize() {
        $('#b-login-jb').on('click', () => this.quickStart());

        // '설명' 클릭 시 아이디/비밀번호 로그인 폼을 펼친다 (앱마켓 심사 테스트용 — 평소 숨김).
        $('#b-login-more').on('click', () => {
            const $f = $('#b-login-idpw');
            $f.slideToggle(200, () => {
                if ($f.is(':visible')) $f.find('input[name=mem_id]').trigger('focus');
            });
        });

        // 아이디는 대부분 핸드폰번호 → 숫자(0으로 시작)면 자동 대시(010-xxxx-xxxx).
        // 장비불러 phoneNumber() 헬퍼(common.js) 사용. 숫자가 아닌(일반) 아이디는 그대로 둔다.
        $('#b-login-idpw input[name=mem_id]').on('input', function () {
            const raw = this.value;
            const digits = raw.replace(/[^0-9]/g, '');
            if (/^[0-9-]*$/.test(raw) && /^0/.test(digits)) {
                this.value = Util.phoneNumber(raw);
            }
        });
    }

    quickStart() {
        // 안드로이드 앱함수 호출은 $j.F.App 경유 (앱 미존재 시 모듈이 안내).
        // 요청 서브앱 코드(G5.app, 악덕=BD)를 실어 본앱이 콜백 대상을 식별하게 한다.
        const app = (typeof G5 !== 'undefined' && G5.app) ? G5.app : 'BD';

        // 토큰 발급~딥링크 회신까지 시간이 걸려 "로그인 진행중" 오버레이를 표시한다.
        // 성공 시 /b/login/onetime 으로 페이지 이동하며 오버레이는 자연 소멸.
        // 지연되면 '닫기' 버튼을 노출(사용자가 직접 닫을 수 있게),
        // 본앱에서 인증 없이 돌아오면(가시성 복귀) 자동 해제한다.
        this.showQuickStartLoading();

        // 장비불러 앱이 없으면 앱(1.72~)이 0 을 돌려준다 → 아이디·비밀번호 칸을 연다.
        //   다른 마켓(구글 플레이)으로 보내지 않는다 — 원스토어가 그 이동을 사유로 1.71 을 반려했다(2026-10-26).
        //   옛 앱(1.70)은 늘 1 을 돌려주므로 동작이 그대로다. iOS(jbLogin ok:0)·앱 밖도 같은 길로 간다.
        if (!$j.F.App.jbLogin(app)) {
            this.hideQuickStartLoading();
            this.openIdPw();
            $j.Ui.Toast.show(JB_MISSING_MSG, { timeout: 3500 });
        }
    }

    /** 아이디·비밀번호 칸을 연다(이미 열려 있으면 그대로) — 장비불러 앱이 없을 때 빠른 시작이 여기로 온다. */
    openIdPw() {
        const $f = $('#b-login-idpw');
        const focus = () => $f.find('input[name=mem_id]').trigger('focus');
        if ($f.is(':visible')) { focus(); return; }
        $f.slideDown(200, focus);
    }

    showQuickStartLoading() {
        this.hideQuickStartLoading(); // 중복 클릭 대비 기존 타이머/핸들러 정리

        const html = `
<div id="b-qs-loading" style="position:fixed;inset:0;z-index:var(--z-index-loading);display:flex;align-items:center;justify-content:center;background:rgba(20,14,28,.72);backdrop-filter:blur(6px)">
  <div style="text-align:center;padding:0 32px;max-width:320px">
    <div style="width:52px;height:52px;margin:0 auto 20px;border:3px solid rgba(255,255,255,.18);border-top-color:#fff;border-radius:50%;animation:b-spin .8s linear infinite"></div>
    <p style="font-size:16px;font-weight:700;color:#fff;margin:0 0 6px">장비불러 계정으로 로그인 중…</p>
    <p style="font-size:13px;color:rgba(255,255,255,.7);margin:0;line-height:1.5">장비불러 앱에서 인증을 진행하고 있어요.<br>잠시만 기다려 주세요.</p>
    <div class="b-qs-delay" style="display:none;margin-top:24px">
      <p style="font-size:13px;color:rgba(255,255,255,.85);margin:0 0 12px;line-height:1.5">로그인이 지연되고 있어요.<br>닫고 다시 시도해 주세요.</p>
      <button type="button" class="b-qs-close" style="height:42px;padding:0 26px;border:1px solid rgba(255,255,255,.45);border-radius:21px;background:transparent;color:#fff;font-size:14px;font-weight:600;cursor:pointer">닫기</button>
    </div>
  </div>
</div>`;
        $('body').append(html);
        $('#b-qs-loading').find('.b-qs-close').on('click', () => this.hideQuickStartLoading());

        // 지연 안내·닫기 버튼 노출까지 대기시간
        const DELAY_MS = 15000;
        this._loadingTimer = setTimeout(() => $('#b-qs-loading .b-qs-delay').css('display', 'block'), DELAY_MS);

        // 본앱으로 갔다가 인증 없이 돌아온 경우 자동 해제
        this._onVisible = () => { if (!document.hidden) this.hideQuickStartLoading(); };
        document.addEventListener('visibilitychange', this._onVisible);
        window.addEventListener('pageshow', this._onVisible);
    }

    hideQuickStartLoading() {
        if (this._loadingTimer) { clearTimeout(this._loadingTimer); this._loadingTimer = null; }
        if (this._onVisible) {
            document.removeEventListener('visibilitychange', this._onVisible);
            window.removeEventListener('pageshow', this._onVisible);
            this._onVisible = null;
        }
        $('#b-qs-loading').remove();
    }
}
